/**
 * Copyright (c) Microsoft. All rights reserved.
 */
import { __awaiter } from "tslib";
import * as React from 'react';
import { copyKey, selectAllKey } from '../utils/keyboardUtils';
import { bracketDataAttribute, LabelerKeyCodes, tokenDataAttribute } from '../utils/labelerConstants';
export const useLabelerGlobalEventListeners = ({ text, containerRef, selectionStore, tokenToCharMap, globalEventExceptionSelectors }) => {
    const keyDownCallback = (e) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if ((_a = globalEventExceptionSelectors === null || globalEventExceptionSelectors === void 0 ? void 0 : globalEventExceptionSelectors.onKeyDown) === null || _a === void 0 ? void 0 : _a.call(globalEventExceptionSelectors, e)) {
            return;
        }
        let handled = true;
        if (selectionStore.isSelectionInProgress && e.key === LabelerKeyCodes.Escape) {
            selectionStore.cancelSelection();
        }
        else if (selectionStore.isSelectionInProgress && copyKey(e) && navigator.clipboard) {
            yield navigator.clipboard.writeText(text.slice(tokenToCharMap.get(selectionStore.selectionStart).startIndex, tokenToCharMap.get(selectionStore.selectionEnd).endIndex + 1));
        }
        else if (selectAllKey(e) && selectionStore.isSelectionInProgress) {
            selectionStore.selectAll();
        }
        else {
            handled = false;
        }
        if (handled) {
            e.preventDefault();
        }
    });
    const mouseDownCallback = (e) => {
        var _a, _b;
        if ((_a = globalEventExceptionSelectors === null || globalEventExceptionSelectors === void 0 ? void 0 : globalEventExceptionSelectors.onMouseDown) === null || _a === void 0 ? void 0 : _a.call(globalEventExceptionSelectors, e)) {
            return;
        }
        const clickedElement = e.target;
        const isInsideLabeler = (_b = containerRef.current) === null || _b === void 0 ? void 0 : _b.contains(clickedElement);
        const isToken = clickedElement.hasAttribute(tokenDataAttribute);
        const isBracket = clickedElement.hasAttribute(bracketDataAttribute);
        if (!(isInsideLabeler && (isToken || isBracket))) {
            selectionStore.cancelSelection();
        }
    };
    const mouseWheelCallback = (e) => {
        var _a;
        if ((_a = globalEventExceptionSelectors === null || globalEventExceptionSelectors === void 0 ? void 0 : globalEventExceptionSelectors.onWheel) === null || _a === void 0 ? void 0 : _a.call(globalEventExceptionSelectors, e)) {
            return;
        }
        if (selectionStore.isSelectionInProgress) {
            selectionStore.cancelSelection();
        }
    };
    React.useEffect(() => {
        document.addEventListener('keydown', keyDownCallback);
        document.addEventListener('wheel', mouseWheelCallback);
        document.addEventListener('mousedown', mouseDownCallback);
        return () => {
            document.removeEventListener('keydown', keyDownCallback);
            document.removeEventListener('wheel', mouseDownCallback);
            document.removeEventListener('mousedown', mouseDownCallback);
        };
    }, [text, containerRef, selectionStore]);
};
//
